export default "__VITE_ASSET__49947aa0__"